import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../reducers'
import { styled } from '@mui/material/styles'
import {
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material'
import Menu, { MenuProps } from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { Clear as ClearIcon } from '@mui/icons-material'
import SaveIcon from '@mui/icons-material/Save'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import { useStyles } from '../CaseDiagnosisStyles'
import OptionsDropDown from './optionsDropDown'
import { saveSlideDiagnosis, getSampleLocationData } from '../../../actions'
import FormControl from '@mui/material/FormControl'

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    style={{ left: '988px !important' }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    width: '475px',
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '&:active': {
        // backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
      '&:hover': {
        backgroundColor: '#fff',
      },
    },
  },
}))

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const styleOptions = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
}

export default function CustomizedMenus({
  trfBarcode,
  currentLocation,
  currentSlideBarcode,
  currentStain,
  isDiagnosed,
  isDontReport,
  isReadOnlyMode,
  handleViewerOpen,
  open,
  anchorEl,
  setAnchorEl,
}) {
  const classes = useStyles()

  const dispatch = useDispatch()
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [selectedOption, setSelectedOption] = useState({})
  const [isSelected, setSelected] = useState(false)
  const [toggle, setToggle] = useState(false)
  const [isPositive, setIsPositive] = useState('')
  const [hasCoreSelection, setHasCoreSelection] = useState(false)
  const [saveBtnClicked, setSaveBtnClicked] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [isDisableSave, setDisableSave] = useState(false)
  const [isChecked, setChecked] = useState(isDontReport)
  const [savedDiagnosisData, setSavedDiagnosisData] = useState({} as any)
  const [slideDiagnosisObj, setSlideDiagnosisObj] = useState([] as any)
  const slideDiagnosisOptions = useSelector((state: RootState) => state.setSlideDiagnosisOptions)
  const imageQualityOptions = useSelector((state: RootState) => state.setImageQualityOptions)
  const [imageQuality, setImageQuality] = React.useState<string[]>([])
  const [imageQualityObject, setImageQualityObject] = useState([] as any)
  const [imageOptions, setImageOptions] = useState([] as any)
  const [savedImageQuality, setSavedImageQuality] = useState([] as any)
  const { procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const savedDiagnosisResult = useSelector((state: RootState) => state.getSlideDiagnosisData)
  const sampleData = useSelector((state: RootState) => state.addSampleLocationData)
  const { re_save_success, re_save_error } = useSelector((state: RootState) => state.saveSlideDiagnosisData)
  const { role } = useSelector((state: RootState) => state.userLogin)
  
  // Check if only image quality has changed (for read-only mode)
  const hasOnlyImageQualityChanged = () => {
    if (!isReadOnlyMode) return false
    const currentImageQualityStr = JSON.stringify(imageOptions || [])
    const savedImageQualityStr = JSON.stringify(savedImageQuality || [])
    return currentImageQualityStr !== savedImageQualityStr
  }
  
  // Determine if save button should be disabled
  const isSaveButtonDisabled = () => {
     // In read-only mode (completed cases), enable save only if only image quality changed (for all users including admin)
    if (isReadOnlyMode) {
      return !hasOnlyImageQualityChanged() || isLoading
    }
  // Normal mode: Admin can always save (unless loading or explicitly disabled)
    if (role === 'NL_WOMA_ADMIN') {
    return isLoading || isDisableSave
  }
     // Normal mode: use existing logic for regular users
     return isLoading || isDisableSave
  }
  
  const getButtonClassName = () => {
    return isSaveButtonDisabled() ? `${classes.disableBtn} ` : `${classes.btn}`
  }
  const getCancelButtonClassName = () => (isLoading ? `${classes.disabledCancelBtn}` : `${classes.buttonMargin}`)
  const getCheckboxClassName = () => (isReadOnlyMode ? `${classes.disabledCheckbox} ` : `${classes.checkbox}`)

  useEffect(() => {
    if (imageQualityOptions?.payload?.length > 0) {
      try {
        const imageQuality = imageQualityOptions.payload[0]?.options
          ? JSON.parse(imageQualityOptions.payload[0].options)
          : []

        const classificationQuality = imageQualityOptions.payload[1]?.options
          ? JSON.parse(imageQualityOptions.payload[1].options)
          : []

        const stainQuality = imageQualityOptions.payload[2]?.options
          ? JSON.parse(imageQualityOptions.payload[2].options)
          : []

        const newObjects = [...imageQuality, ...classificationQuality, ...stainQuality]
        setImageQualityObject(newObjects)
      } catch (error) {
        console.error('Error parsing image quality options:', error)
        setImageQualityObject([])
      }
    }
  }, [imageQualityOptions])

  useEffect(() => {
    if (currentSlideBarcode) {
      if (savedDiagnosisResult && savedDiagnosisResult.payload) {
        const diagnosis = savedDiagnosisResult.payload
        const currentDiagnosis = diagnosis.filter((stainObject) => {
          if (stainObject.sampleBarcode.toLowerCase() === currentSlideBarcode.toLowerCase()) return stainObject
        })
        if (currentDiagnosis[0]?.imageQuality) {
          try {
            const parsedOutput = JSON.parse(currentDiagnosis[0].imageQuality)
            setImageOptions(parsedOutput)
            setSavedImageQuality(parsedOutput) // Store original saved image quality
          } catch (error) {
            console.error('Error parsing image quality:', error)
            setImageOptions([])
            setSavedImageQuality([])
          }
        } else {
          setImageOptions([])
          setSavedImageQuality([])
        }
        setSavedDiagnosisData(currentDiagnosis[0])
        if (currentDiagnosis[0]) {
          setIsPositive(
            currentDiagnosis[0].diagnosisStatus
              ? currentDiagnosis[0].diagnosisStatus
              : currentDiagnosis[0].slideReportText,
          )
        }
        setChecked(currentDiagnosis[0].isDontReport)
        setDisableSave(true)
        if (slideDiagnosisObj && !slideDiagnosisObj.positivityOptions) {
          setDisableSave(false)
        }
      }
    }
  }, [currentSlideBarcode, savedDiagnosisResult])

  useEffect(() => {
    checkRequired(selectedOption, savedDiagnosisData)
  }, [currentStain, isPositive, selectedOption, isChecked])

  useEffect(() => {
    if (isChecked) {
      setDisableSave(false)
    }
  }, [isChecked])

  useEffect(() => {
    setChecked(isDontReport)
  }, [isDontReport])

  useEffect(() => {
    setSelectedOption({})
    if (slideDiagnosisOptions && slideDiagnosisOptions.payload && slideDiagnosisOptions.payload.length > 0) {
      if (slideDiagnosisOptions.payload) {
        getSlideDiagnosisObj(slideDiagnosisOptions.payload)
      }
    }
  }, [slideDiagnosisOptions, currentSlideBarcode, currentStain])

  const handleClose = async () => {
    setAnchorEl(null)
  }
  const handleSelectDropdown = (title, e) => {
    const key = title
    // Converting 'Select' string to null
    selectedOption[key] = e.target.value === 'Select' ? null : e.target.value
    if (currentStain.toLowerCase() === 'alcian blue') {
      Object.assign(savedDiagnosisData, selectedOption)
      setSavedDiagnosisData(savedDiagnosisData)
      setSelectedOption(selectedOption)
    } else if (
      isPositive === 'Negative' &&
      currentStain.toLowerCase() !== 'modified pap' &&
      currentStain.toLowerCase() !== 'he'
    ) {
      setSavedDiagnosisData(savedDiagnosisData)
    } else {
      Object.assign(savedDiagnosisData, selectedOption)
      setSavedDiagnosisData(savedDiagnosisData)
      setSelectedOption(selectedOption)
    }
    checkRequired(selectedOption, savedDiagnosisData)
    setToggle(!toggle)
  }

  const handleImageFeedbackChange = (val) => {
    setImageOptions(val)
    // In read-only mode, only enable save if only image quality changed
    if (isReadOnlyMode) {
      const hasChanged = JSON.stringify(val || []) !== JSON.stringify(savedImageQuality || [])
      // Don't set disableSave here - let getButtonClassName handle it
    } else {
      setDisableSave(false)
    }
  }

  const handleChange = (option) => {
    setIsPositive(option)
    savedDiagnosisData.diagnosisStatus = option
    if (currentStain.toLowerCase() === 'alcian blue') {
      selectedOption['PAS Positive'] = null
      savedDiagnosisData['PAS Positive'] = null
    } else if (option !== 'Positive') {
      savedDiagnosisData.slideReportText = ''
      savedDiagnosisData.slidePositiveReportText = ''
      Object.keys(selectedOption).map((key) => {
        selectedOption[key] = null
      })
      savedDiagnosisData['% of Cells'] = null
      savedDiagnosisData['Staining'] = null
      savedDiagnosisData['Patterns'] = null
      savedDiagnosisData['PAS Positive'] = null
    }
    setSelectedOption(selectedOption)
    setSavedDiagnosisData(savedDiagnosisData)
    setToggle(!toggle)
    setSelected(true)
    checkRequired(selectedOption, savedDiagnosisData)
  }

  const saveBtnClickHandler = async () => {
    setLoading(true)
    
    // In read-only mode, if only image quality changed, save only image quality
    if (isReadOnlyMode && hasOnlyImageQualityChanged()) {
      const currentDiagnosis = savedDiagnosisResult.payload.filter((stainObject) => {
        if (stainObject.sampleBarcode.toLowerCase() === currentSlideBarcode.toLowerCase()) return stainObject
      })
      const currentObject = currentDiagnosis[0]
      if (!currentObject) {
        console.error('Current diagnosis object not found')
        setLoading(false)
        return
      }
      // Only update image quality, preserve all other fields
      currentObject.imageQuality = imageOptions
      await dispatch(saveSlideDiagnosis({ currentSlideBarcode: currentSlideBarcode, data: currentObject }))
      // Update saved image quality reference
      setSavedImageQuality(imageOptions)
      setOpenSuccessSnackBar(true)
      setTimeout(() => setOpenSuccessSnackBar(false), 2000)
      setLoading(false)
      setSaveBtnClicked(!saveBtnClicked)
      return
    }
    
    // Normal save flow for non-read-only mode
    savedDiagnosisData.diagnosisStatus = isPositive
    savedDiagnosisData.slideReportText = ''
    savedDiagnosisData.slidePositiveReportText = ''
    if (isPositive !== 'Negative' && isPositive !== 'Positive') {
      savedDiagnosisData.diagnosisStatus = null
      savedDiagnosisData.slidePositiveReportText = ''
      savedDiagnosisData.slideReportText = isPositive
    } else if (isPositive === 'Positive' && savedDiagnosisData['Staining']) {
      savedDiagnosisData.slidePositiveReportText = savedDiagnosisData['Staining']
      // delete savedDiagnosisData['Staining']
    }
    const data = Object.assign(savedDiagnosisData, selectedOption)
    const currentDiagnosis = savedDiagnosisResult.payload.filter((stainObject) => {
      if (stainObject.sampleBarcode.toLowerCase() === currentSlideBarcode.toLowerCase()) return stainObject
    })
    const currentObject = currentDiagnosis[0]
    Object.keys(currentObject).forEach(function (key) {
      if (data[key]) {
        currentObject[key] = data[key]
      }
    })
    savedDiagnosisData.isDiagnosed = true
    savedDiagnosisData.isDontReport = isChecked
    currentObject.isDiagnosed = true
    currentObject.isDontReport = isChecked
    currentObject.imageQuality = imageOptions
    savedDiagnosisData.imageQuality = imageOptions
    await dispatch(saveSlideDiagnosis({ currentSlideBarcode: currentSlideBarcode, data: currentObject }))
    // Refresh sample tree in store so other slides reflect updated flags
    await dispatch(getSampleLocationData({ trfBarcode: trfBarcode, procedureCode: procedureCodeId }))
    setOpenSuccessSnackBar(true)
    setTimeout(() => setOpenSuccessSnackBar(false), 2000)
    setSelectedOption({})
    setLoading(false)
    setDisableSave(true)
    setSaveBtnClicked(!saveBtnClicked)
    // Update saved image quality reference
    setSavedImageQuality(imageOptions)

    // Refresh the diagnosis status by calling handleViewerOpen with updated stain data
    // This ensures the visual state (button colors, header colors) is updated correctly
    if (sampleData && sampleData.payload) {
      const currentLocationData = sampleData.payload.filter((item) => item.location === currentLocation)
      const location = currentLocationData[0]
      if (location && location.children && location.children.length > 0) {
        const stains: any[] = []
        location.children.map((slide) => {
          if (
            slide.type === 'expandable' &&
            slide.children &&
            slide.children.length > 0 &&
            slide.children[0].type === 'expandable' &&
            slide.children[0].children.length > 0
          ) {
            slide.children[0].children?.map((subChild, index1) => {
              const name =
                subChild.sampleBarcode +
                ' ' +
                (subChild.sampleStain ? subChild.sampleStain : subChild.children[0].sampleStain)
              const type = subChild.type
              const isDiagnosed = subChild.isDiagnosed === null ? false : subChild.isDiagnosed
              const isDontReport = subChild.isDontReport === null ? false : subChild.isDontReport
              stains.push({
                name: name,
                type: type,
                isDiagnosed: isDiagnosed,
                isDontReport: isDontReport,
              })
            })
          } else if (slide.type === 'expandable' && slide.children && slide.children.length > 0) {
            slide.children?.map((subChild, index2) => {
              const name = subChild.sampleBarcode + ' ' + subChild.sampleStain
              const type = subChild.type
              const isDiagnosed = subChild.isDiagnosed === null ? false : subChild.isDiagnosed
              const isDontReport = subChild.isDontReport === null ? false : subChild.isDontReport
              stains.push({
                name: name,
                type: type,
                isDiagnosed: isDiagnosed,
                isDontReport: isDontReport,
              })
            })
          } else if (slide.type === 'checkbox') {
            const name = slide.sampleBarcode + ' ' + slide.sampleStain
            const type = slide.type
            const isDiagnosed = slide.isDiagnosed === null ? false : slide.isDiagnosed
            const isDontReport = slide.isDontReport === null ? false : slide.isDontReport
            stains.push({
              name: name,
              type: type,
              isDiagnosed: isDiagnosed,
              isDontReport: isDontReport,
            })
          }
        })

        // Call handleViewerOpen with updated stain data to refresh the visual state
        // Override the current slide's diagnosis flags to reflect the just-saved values
        const currentName = `${currentSlideBarcode} ${currentStain}`
        const normalized = (val: string) => (val || '').toUpperCase()
        const updatedStains = stains.map((s) => {
          if (normalized(s.name) === normalized(currentName)) {
            return {
              ...s,
              isDiagnosed: true,
              isDontReport: isChecked,
            }
          }
          return s
        })

        await handleViewerOpen({
          stain: currentStain,
          slide: currentSlideBarcode,
          trfBarcode: trfBarcode,
          location: currentLocation,
          stainData: updatedStains,
          isShow: false,
        })
      }
    }
  }

  const getSlideDiagnosisObj = (payload) => {
    const data = payload.filter((obj) => {
      return obj.stain.toLowerCase() === currentStain.toLowerCase()
    })[0]
    if (data && data.options) {
      setHasCoreSelection(true)
    } else {
      setHasCoreSelection(false)
    }
    setSlideDiagnosisObj(data)
  }

  const handlePositivityOptionTitle = (type) => {
    switch (type) {
      case '% of Cells':
        return 'IHC Coverage/PAS'
      case 'Staining':
        return 'IHC Stain Intensity'
      case 'PAS Positive':
        return 'Non IHC Slide Status'
      case 'Patterns':
        return 'Patterns'
      default:
        return type
    }
  }

  const checkRequired = (selection, savedDiagnosisData) => {
    const stain = currentStain.toLowerCase()
    if (slideDiagnosisObj && !slideDiagnosisObj.positivityOptions) {
      setDisableSave(false)
    } else {
      if (stain === 'he' || stain === 'modified pap') {
        // Require both Squamous Epithelium and Columnar Epithelium for HE / Modified PAP
        const squamous =
          selection['Squamous Epithelium'] !== undefined && selection['Squamous Epithelium'] !== null
            ? selection['Squamous Epithelium']
            : savedDiagnosisData && savedDiagnosisData['Squamous Epithelium']

        const columnar =
          selection['Columnar Epithelium'] !== undefined && selection['Columnar Epithelium'] !== null
            ? selection['Columnar Epithelium']
            : savedDiagnosisData && savedDiagnosisData['Columnar Epithelium']

        const hasBoth = squamous !== undefined && squamous !== null && columnar !== undefined && columnar !== null
        setDisableSave(!hasBoth)
      } else if (stain === 'alcian blue') {
        if (Object.keys(selection).length && selection['PAS Positive']) {
          setDisableSave(false)
        } else {
          setDisableSave(true)
        }
      } else if (isPositive === 'Positive') {
        if (Object.keys(selection).length) {
          if (stain === 'alcian blue') {
            if (selection['PAS Positive'] && selection['Patterns'] && selection['% of Cells']) {
              setDisableSave(false)
            } else {
              setDisableSave(true)
            }
          } else if (stain === 'cdx-2') {
            if (selection['% of Cells']) {
              setDisableSave(false)
            } else {
              setDisableSave(true)
            }
          } else if (stain === 'muc2') {
            if (selection['% of Cells']) {
              setDisableSave(false)
            } else {
              setDisableSave(true)
            }
          } else if (stain === 'p53') {
            if (Object.keys(selection).length > 0) {
              setDisableSave(false)
            } else {
              setDisableSave(true)
            }
          } else if (stain === 'amacr') {
            if (
              Object.keys(selection).length > 0 &&
              savedDiagnosisData['% of Cells'] &&
              savedDiagnosisData['Staining']
            ) {
              setDisableSave(false)
            } else {
              setDisableSave(true)
            }
          } else if (stain === 'ki67') {
            if (
              Object.keys(selection).length > 0 &&
              (savedDiagnosisData['Staining'] ||
                (savedDiagnosisData['% of Cells'] && savedDiagnosisData['Patterns']) ||
                savedDiagnosisData['% of Cells'])
            ) {
              setDisableSave(false)
            } else {
              setDisableSave(true)
            }
          } else if (stain === 'p16') {
            if (Object.keys(selection).length > 0 && savedDiagnosisData['Staining']) {
              setDisableSave(false)
            } else {
              setDisableSave(true)
            }
          }
        } else {
          setDisableSave(true)
        }
        if (isPositive && stain === 'helicobacter pylori') {
          setDisableSave(false)
        }
      } else if (!isPositive) {
        setDisableSave(true)
      } else {
        setDisableSave(false)
      }
    }
  }

  return (
    <div className={classes.customizedMenu} style={{ marginLeft: '8px' }}>
      {openSuccessSnackBar && re_save_success && (
        <SuccessSnackBar message="Successfully saved slide diagnosis status" />
      )}
      {openSuccessSnackBar && re_save_error && <ErrorSnackBar message="Failed to save slide diagnosis status" />}
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        style={{ padding: '0px' }}
      >
        <div
          className={
            isDiagnosed
              ? isDontReport
                ? classes.dontReportTitle
                : classes.dropdownTitle
              : classes.notDiagnoseddropdownTitle
          }
        >
          <div className={classes.dropdownLabel}>Slide diagnosis</div>
        </div>
        {slideDiagnosisObj && slideDiagnosisObj.positivityOptions && (
          <>
            {hasCoreSelection && savedDiagnosisData && slideDiagnosisObj && (
              <div style={{ padding: '10px 0px 10px 16px' }}>
                <fieldset className={classes.diagnosisFieldset}>
                  <legend> IHC Status </legend>

                  {typeof slideDiagnosisObj.positivityOptions !== 'undefined' &&
                    slideDiagnosisObj.options &&
                    slideDiagnosisObj.options.length &&
                    slideDiagnosisObj.options[0].options &&
                    slideDiagnosisObj.options[0].options.length &&
                    slideDiagnosisObj.options[0].options.map((option, index) => {
                      return (
                        <MenuItem disableRipple key={index}>
                          <input
                            onChange={(e) => handleChange(e.target.value)}
                            id={option}
                            type="radio"
                            name="option"
                            key={option}
                            value={option}
                            disabled={isReadOnlyMode || isLoading || isChecked}
                            checked={
                              isSelected
                                ? isPositive !== undefined && option === isPositive
                                  ? true
                                  : false
                                : option === savedDiagnosisData.diagnosisStatus
                                ? true
                                : false
                            }
                          />
                          <label htmlFor={option}>{option}</label>
                        </MenuItem>
                      )
                    })}
                </fieldset>
                {typeof slideDiagnosisObj.positivityOptions !== 'undefined' &&
                  slideDiagnosisObj.positivityOptions.length > 0 && (
                    <fieldset className={classes.diagnosisFieldset} style={{ marginTop: '10px' }}>
                      <legend>Positivity options</legend>
                      {typeof slideDiagnosisObj.positivityOptions !== 'undefined' &&
                        slideDiagnosisObj.positivityOptions.map((positivityOption: any, index) => {
                          return (
                            <MenuItem disableRipple key={index}>
                              <div>
                                <Typography color="textSecondary" component="span">
                                  <div className={classes.optionTitle}>
                                    {handlePositivityOptionTitle(positivityOption.title)}
                                    {positivityOption.required && '*'}
                                  </div>
                                  <div className={classes.optionValue} style={{ width: '178px' }}>
                                    {isPositive !== undefined && toggle !== undefined && savedDiagnosisData && (
                                      <OptionsDropDown
                                        role={role}
                                        isPositive={isPositive}
                                        currentStain={currentStain}
                                        savedDiagnosisData={savedDiagnosisData}
                                        positivityOption={positivityOption}
                                        selectedOption={selectedOption}
                                        handleSelectDropdown={handleSelectDropdown}
                                        isReadOnlyMode={
                                          isReadOnlyMode || isLoading || isChecked
                                        }
                                      />
                                    )}
                                  </div>
                                </Typography>
                              </div>
                            </MenuItem>
                          )
                        })}
                    </fieldset>
                  )}
              </div>
            )}

            {!hasCoreSelection &&
              savedDiagnosisData &&
              slideDiagnosisObj &&
              typeof slideDiagnosisObj.positivityOptions !== 'undefined' && (
                <div style={{ padding: '10px 0px 10px 16px' }}>
                  <fieldset className={classes.diagnosisFieldset}>
                    <legend> Positivity options </legend>
                    {slideDiagnosisObj.positivityOptions.map((positivityOption: any, index) => {
                      return (
                        <MenuItem disableRipple key={index}>
                          <div>
                            <Typography color="textSecondary" component="span">
                              <div className={classes.optionTitle}>
                                {positivityOption.title}
                                {positivityOption.required && '*'}
                              </div>
                              {toggle !== undefined && (
                                <OptionsDropDown
                                  savedDiagnosisData={savedDiagnosisData}
                                  positivityOption={positivityOption}
                                  handleSelectDropdown={handleSelectDropdown}
                                  isReadOnlyMode={
                                    isReadOnlyMode || isLoading || isChecked
                                  }
                                  selectedOption={selectedOption}
                                />
                              )}
                            </Typography>
                          </div>
                        </MenuItem>
                      )
                    })}
                  </fieldset>
                </div>
              )}
            <div>
              <div>
                <FormControl sx={{ m: 1, width: 432 }} size="small">
                  <Autocomplete
                    multiple
                    value={imageOptions}
                    disableClearable
                    id="combo-box-demo"
                    options={imageQualityObject.map((value) => `${value.code} - ${value.description}`)}
                    onChange={(e, val) => handleImageFeedbackChange(val)}
                    sx={{ width: 432, marginTop: '15px' }}
                    renderInput={(params) => <TextField {...params} label={`Image Quality Feedback`} />}
                  />
                </FormControl>
              </div>
            </div>
          </>
        )}
        <div className={classes.buttonActions}>
          <Button
            variant="outlined"
            endIcon={<ClearIcon />}
            className={getCancelButtonClassName()}
            onClick={handleClose}
            style={{ marginBottom: '10px', float: 'right' }}
          >
            Close
          </Button>
          <Button
            variant="outlined"
            endIcon={<SaveIcon style={{ color: '#fff' }} />}
            className={getButtonClassName()}
            disabled={isSaveButtonDisabled()}
            style={{ marginBottom: '10px', float: 'right', width: '110px' }}
            onClick={() => saveBtnClickHandler()}
          >
            Save
          </Button>
          {isDontReport !== null && (
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isReadOnlyMode ? true : false}
                  checked={isChecked}
                  onClick={() => {
                    setChecked(!isChecked)
                  }}
                  className={getCheckboxClassName()}
                />
              }
              label="Don't report"
            />
          )}
          {isLoading && (
            <CircularProgress
              style={{ width: '30px', height: '30px', marginLeft: '4%', marginTop: '3px', color: '#0A688D' }}
            />
          )}
        </div>
      </StyledMenu>
    </div>
  )
}
